import AssetDeclarationForm from "@components/Assets/asset.form";
import React from "react";
import { useParams } from "react-router-dom";

function DeclearAssetPage() {
  const { assetType } = useParams<{ assetType: string }>();

  if (assetType !== "audio" && assetType !== "video") {
    return (
      <>
        <div className="max-w-4xl mx-auto p-6 bg-gray rounded shadow-md mt-5">
          <h2 className="text-red-500">Invalid asset type: {assetType}</h2>
          <p>Please select either "audio" or "video".</p>
        </div>
      </>
    );
  }
  return (
    <div>
      <AssetDeclarationForm assetType={assetType} />
    </div>
  );
}

export default DeclearAssetPage;
